import React from "react";
import "./Founder.css"
import dummyImg from "../../assets/images/dummy-member.jpg";
import founderImg from "../../assets/images/founder.jpg";

const Founder = () => {
  return (
    <div className="inner-page-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12 col-md-12 col-sm-12">
            <div className="title-box">
              <h2>Late. Sri. Pendekanti Venkata Subbaiah</h2>
              <p className="mt-3">
                Former Union Minister of State for Home & Parliamentary Affairs
                and Former Governor of Bihar and Karnataka
              </p>
            </div>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-lg-8 col-md-8 col-sm-12">
            <div className="details-box">
              <p>
                Sri Pendekanti Venkatasubbaiah, one of the veteran statesmen of
                Independent India, held many important positions in his
                lifetime. He served in the capacities of the Union Minister of
                State for Home & Parliamentary Affairs (1980-84), the Governor
                of Bihar, and later, of Karnataka.
              </p>
              <p>
                Sri Pendekanti Venkatasubbaiah was born in an affluent family of
                agriculturists on 18th June, 1921 at Sanjamala, a village in the
                erstwhile Princely State of Banaganapalli in Kurnool District of
                Andhra Pradesh. He took keen interest in the national movement
                while he was a student in Nandyal, the constituency he
                represented subsequently for 27 years in Lok Sabha. He dedicated
                himself to the national movement and fought against oppression
                and even, braving imprisonment.
              </p>
              <p>
                Sri Venkatasubbaiah was secular in his outlook throughout his
                life and fought firmly against all kinds of inequalities and
                oppression. His vision for an egalitarian and progressive future
                reflects in the institutions that he founded and inspired.
              </p>
              <p>
                A Gandhian to the core, he had a passionate interest in
                Education, Khadi and Co-operation. He started several
                educational institutions, hostels for poor boys and Co-operative
                Societies.
              </p>
              <p>
                Vasavi College of Engineering was established in 1981 by Vasavi
                Academy of Education under the stewardship of Late Sri
                Pendekanti Venkata Subbaiah, a veteran statesman of independent
                India and by a few eminent people from different walks of life.
                The College of Engineering represents a rich tradition of
                excellence in technology based education in a stimulating
                environment.
              </p>
            </div>
          </div>
          <div className="col-lg-4 col-md-4 col-sm-12">
            <div className="about-img">
                  <img src={dummyImg} className="img-fluid" alt="Sri Pendekanti Venkatasubbaiah"/>
                  <h3>Sri Pendekanti Venkatasubbaiah</h3>
                  <p>
                    Former Union Minister of State for Home & Parliamentary Affairs and Former Governor of Bihar and Karnataka
                  </p>
              </div>
          </div>
        </div>
      </div>

    </div>
  );
};

export default Founder;
